import { CircularProgress } from "@material-ui/core";
import React from "react";
import { AuthConsumer } from "./providers/authProvider";

export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <div style={{display:"flex", justifyContent:"center"}}><CircularProgress /></div>;
        }}
    </AuthConsumer>
);